import React from "react";
import classes from "./Tabs.module.css";
import Tab from "./Tab/Tab";
import { useTranslation } from 'react-i18next';

const tabs = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);
    const TABS = [t("DEN"), t("NEST"), t("EVENT")];
    return (
        <ul className={classes.Nav}>
            {
                TABS.map((v, idx) => {
                    return <Tab title={v} key={idx} clicked={props.clicked} active={props.active === idx} num={idx} />
                })
            }
        </ul>
    );
}

export default tabs;